export default {
  data () {
    return {
      seoTitle: null,
      seoCategory: null,
      // Set by a page's Apollo result() from the entry's
      // excludeFromSearchResults flag: the same checkbox that hides an entry
      // from the site search also tells crawlers not to index the page
      // (unlisted pages, e.g. QR-only content). Unlisted != protected.
      seoNoindex: false
    }
  },
  head () {
    const meta = [
      { hid: 'description', name: 'description', content: this.getFullSeoTitle },
      { hid: 'og:description', property: 'og:description', content: this.getFullSeoTitle }
    ]
    if (this.seoNoindex) {
      meta.push({ hid: 'robots', name: 'robots', content: 'noindex, nofollow' })
    }
    return {
      title: this.getFullSeoTitle,
      meta
    }
  },
  computed: {
    getFullSeoTitle () {
      if (this.seoCategory) {
        return this.seoTitle ? 'MoTeC - ' + this.seoCategory + ' - ' + this.seoTitle : 'MoTeC - ' + this.seoCategory
      } else {
        return this.seoTitle ? 'MoTeC - ' + this.seoTitle : 'MoTeC'
      }
    }
  }
}
